<template>
  <b-modal
    :id="modalId"
    size="sm"
    centered
    ok-title="OK"
    ok-only
    :title="title"
    @ok="action"
  >
    <p>{{ subTitle }}</p>
  </b-modal>
</template>

<script>
export default {
  name: "Modal",
  props: {
    modalId: {
      type: String,
      default: ""
    },
    action: {
      type: Function,
      default: null
    },
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    toggle: Function,
    exit: Function
  }
};
</script>
<style>
.modal-content {
  width: 90% !important;
  margin: auto;
  font-family: Montserrat;
  color: #202020 !important;
}
#modal-keep-account p,
#modal-keep-account .modal-title {
  font-family: Montserrat;
  color: #000000 !important;
}

.close-button:focus {
  outline: unset !important;
}
.modal-footer {
  border-top: unset !important;
}
</style>
